import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import Revert from "../common/Revert";
const SelectInput = (props) => {
	const hasValue = (typeof props.value !== "undefined" && props.value !== null);
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const hasLabel = !!props.label;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const defaultItem = props.defaultItem ? props.defaultItem : "Kies een optie";
	const defaultItemVisible = props.defaultItemVisible != null ? props.defaultItemVisible : true;
	const defaultValueIndex = props.items.map(item => item.label).indexOf(defaultItem);
	const defaultValue = defaultValueIndex > -1 ? props.items[defaultValueIndex].value : "";

	const small = props.small;
	const value = hasValue ? props.value : defaultValue;
	const sizeClassName = props.size ? `l-grid__col:${props.size}/12` : (small ? "" : props.applySizeClass ? "l-grid__col:12/12" : "");
	const label = hasLabel ? props.label + (props.optional ? " (Optioneel)" : "") : null;
	const info = props.tooltip ? <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.validationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
	const id = generateGuid();

	const revertable = (props.disabled !== true && props.disabled !== 'true') && (props.originalValue !== undefined && props.value !== null) ? props.originalValue !== value : false;

	const style = props.superSmall ?
		{
			background: "none",
			padding: "10px 5px 5px 10px",
			minHeight: "20px"
		} : (small ?
			{ margin: "4px", padding: "2px 30px 2px 2px", minHeight: "2em", color: "black", fontWeight: "normal", width: "auto" }
			: (props.margin ? { marginBottom: props.margin, marginTop: props.margin, height: '50px', padding: '0px' } : props.style ? props.style : null)
		);

	const inputClassName = classnames({
		"c-input__field": true
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": true
	});

	const containerClassName = small ? null : classnames({
		"l-form__item": true,
		"c-input c-input--select ": true,
		"has-value": true,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": props.disabled
	});

	const defaultOption = defaultValueIndex > -1 ? "" : <option value={defaultValue}>{defaultItem}</option>;
	const select = (
		<div className="c-input__wrapper">
			<select
				id={id}
				value={value}
				onChange={props.onChange}
				disabled={props.disabled}
				name={props.name}
				className={inputClassName}
				style={style} >
				{defaultItemVisible ? defaultOption : null}
				{
					props.items.map((item) => {
						return (
							<option key={item.value} value={item.value} >
								{item.label}
							</option>);
					})
				}
			</select>
		</div>);
	return (small ? select :
		<div className={sizeClassName}>
			<div className={containerClassName} style={style}>
				{hasLabel ? <label className={labelClassName} htmlFor={id}>{label}</label> : null}
				{select}
				{info}
				{!revertable || <Revert
					onChange={props.onChange}
					name={props.name}
					originalValue={props.originalValue}
					className="c-undo_select" />}
			</div>
			{validation}
		</div>);
};
SelectInput.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
		PropTypes.bool
	]),
	originalValue: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
		PropTypes.bool
	]),
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	defaultItem: PropTypes.string,
	defaultItemVisible: PropTypes.bool,
	items: PropTypes.array.isRequired,
	small: PropTypes.bool,
	superSmall: PropTypes.bool,
	margin: PropTypes.bool,
	applySizeClass: PropTypes.bool,
	style: PropTypes.object,
	onEnter: PropTypes.func
};
export default SelectInput;